import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import { AdvancedShootTimeValues } from "./AdvancedShootTimeValues";
import { Formula } from "protos/almanac/almanac";
import { FormulaFieldKey } from "portal/utils/shootTime";
import { useTranslation } from "react-i18next";
import { WhenTrue } from "common/utils/types";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import React, { FunctionComponent } from "react";

type AdvancedShootTimeAccordionProps = {
  formula: Formula;
  outlined?: boolean;
} & WhenTrue<
  "canEdit",
  {
    onFieldChange: (field: FormulaFieldKey, value: number) => void;
    onFieldValidityChange: (field: FormulaFieldKey, isValid: boolean) => void;
  }
>;

export const AdvancedShootTimeAccordion: FunctionComponent<
  AdvancedShootTimeAccordionProps
> = ({
  formula,
  outlined = true,
  canEdit,
  onFieldChange,
  onFieldValidityChange,
}) => {
  const { t } = useTranslation();

  return (
    <Accordion
      disableGutters
      elevation={0}
      className="before:hidden bg-transparent"
    >
      <AccordionSummary
        expandIcon={<ExpandMoreIcon />}
        className="min-h-0 px-0 py-0"
        classes={{ content: "my-1" }}
      >
        <Typography
          variant="body2"
          className="uppercase text-darken-400 dark:text-lighten-300"
        >
          {t("views.categoryTemplates.shootTime.advanced")}
        </Typography>
      </AccordionSummary>
      <AccordionDetails className="px-0 pt-1 pb-0">
        {canEdit ? (
          <AdvancedShootTimeValues
            formula={formula}
            outlined={outlined}
            canEdit
            onFieldChange={onFieldChange}
            onFieldValidityChange={onFieldValidityChange}
          />
        ) : (
          <AdvancedShootTimeValues formula={formula} outlined={outlined} />
        )}
      </AccordionDetails>
    </Accordion>
  );
};
